export enum NoteType {
  Internal = 0,
  Customer = 1
}

export interface INoteLog {
  id: string;
  note: string;
  consignmentId: string;
  type: NoteType;
  createdBy: string;
  createdDate: Date;
}

export interface IConsignmentNotes {
  notes: INoteLog[];
}